/*
 * Purchase options on product pages (snippets/osft-purchase-options.liquid).
 *
 * The buttons are selling_plan radios in the product form, so the form
 * already submits the choice. This keeps the rest in step:
 * - the price block shows the subscription price with the regular price
 *   crossed out while a frequency is selected,
 * - the renewal note shows only while a frequency is selected,
 * - the ?selling_plan= URL parameter, so the page can be shared or reloaded
 *   with the same choice.
 *
 * When the size changes, the theme re-renders the section and publishes
 * variantChange with the new HTML; the plan prices are copied from it.
 */
if (!customElements.get('osft-purchase-options')) {
  customElements.define(
    'osft-purchase-options',
    class OsftPurchaseOptions extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.note = this.querySelector('[data-po-note]');

        this.addEventListener('change', () => this.update());
        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }

        this.savePrice();
        this.update(false);
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      get selected() {
        return this.querySelector('input[name="selling_plan"]:checked');
      }

      update(updateUrl = true) {
        const selected = this.selected;
        const planId = selected ? selected.value : '';
        if (this.note) this.note.classList.toggle('osft-po__note--hidden', !planId);
        this.renderPrice(planId ? selected : null);
        if (updateUrl) this.updateUrl(planId);
      }

      // The price block as the server rendered it, i.e. the one-time price
      savePrice() {
        const container = document.getElementById(`price-${this.sectionId}`);
        this.savedPrice = container ? container.innerHTML : null;
      }

      renderPrice(plan) {
        const container = document.getElementById(`price-${this.sectionId}`);
        if (!container || this.savedPrice === null) return;
        container.innerHTML = this.savedPrice;
        if (!plan || !plan.dataset.price || plan.dataset.compare === plan.dataset.price) return;

        const price = container.querySelector('.price');
        const sale = container.querySelector('.price__sale .price-item--sale');
        const regular = container.querySelector('.price__sale s.price-item--regular');
        if (!price || !sale) return;

        price.classList.add('price--on-sale');
        price.classList.remove('price--no-compare');
        sale.textContent = plan.dataset.price;
        if (regular) regular.textContent = plan.dataset.compare;
        const saleLabel = sale.previousElementSibling;
        if (saleLabel && saleLabel.classList.contains('visually-hidden')) {
          saleLabel.textContent = this.dataset.subscriptionPriceLabel;
        }
      }

      updateUrl(planId) {
        const url = new URL(window.location.href);
        if (planId) {
          url.searchParams.set('selling_plan', planId);
        } else {
          url.searchParams.delete('selling_plan');
        }
        window.history.replaceState(window.history.state, '', url.toString());
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;
        const fresh = event.data.html.getElementById(this.id);
        if (fresh) {
          this.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
            const source = fresh.querySelector(`input[name="selling_plan"][value="${input.value}"]`);
            if (!source) return;
            input.dataset.price = source.dataset.price || '';
            input.dataset.compare = source.dataset.compare || '';
            input.disabled = source.disabled;
          });
          // A plan the new size doesn't offer falls back to one-time
          const selected = this.selected;
          if (selected && selected.disabled) {
            const oneTime = this.querySelector('input[name="selling_plan"][value=""]');
            if (oneTime) oneTime.checked = true;
          }
        }

        // The theme just replaced the price block with the new size's one-time price
        this.savePrice();
        this.update();
      }
    }
  );
}
